import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {createSelectOptions, formatTelefone} from "../../../../utils/formatar";
import Select from "react-select";
import {getMotivoContratacaoById} from "../../../../utils/enums";
import {Validacao} from "../../../comum/components/Validacao";

@inject("store")
@observer
export class DetalhamentoJustificativa extends Component {

    static propTypes = {
        isSolicitacaoProrrogacao: PropTypes.bool,
        isSolicitacaoNova: PropTypes.bool,
        isMigracaoAlocacao: PropTypes.bool
    };

    constructor(props) {
        super(props);
    }

    render() {
        const solicitacao = this.props.controller.solicitacao;
        const exibeDetalhesJustificativa = this.props.controller.exibeDetalhesJustificativa;
        const isSolicitacaoProrrogacao = this.props.isSolicitacaoProrrogacao;
        const isMigracaoAlocacao = this.props.isMigracaoAlocacao;
        const componenteEditavel = isSolicitacaoProrrogacao || isMigracaoAlocacao;
        const isProdutoEditavel = this.props.controller.isProdutoEditavel;

        const justificativaContratacaoOptions = this.props.controller.justificativasContratacao ? createSelectOptions(this.props.controller.justificativasContratacao, "id", "nome") : [];
        
        const motivoContratacao = _.get(solicitacao, "motivoContratacao");
        const msgValidacaoJustificativaProrrgacao = this.props.controller.msgValidacaoJustificativaProrrogacao;
        const podeAlterarJustificativa = _.get(this.props.controller, "justificativaInicial.podeAlterarJustificativa");
        const mesmaJustificativa = _.get(this.props.controller, "justificativaInicial.obrigatorioAlterar") && (this.props.controller.solicitacao.justificativaContratacaoId == _.get(this.props.controller, "justificativaInicial.id"))
        const isJustificativaCusteioDireto = this.props.controller.isJustificativaCusteioDireto;
        const isCentroCustoDebitoMediaPulse = this.props.controller.isCentroCustoDebitoMediaPulse;
        const bloqueioJustificativaCusteioDireto = isJustificativaCusteioDireto && !isCentroCustoDebitoMediaPulse;
        
        return (
            <div>
                <h4>Justificativa</h4>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label >Motivo de contratação</Label>
                            <Input value={getMotivoContratacaoById(motivoContratacao).valor} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Justificativa {componenteEditavel && <sup>*</sup>} {/*<FontAwesome name="question-circle" />*/}</Label>
                            {componenteEditavel && podeAlterarJustificativa ? (
                                <div>
                                    <Select value={this.props.controller.solicitacao.justificativaContratacaoId}
                                            options={justificativaContratacaoOptions}
                                            onChange={(value) => this.props.controller.setJustificativaContratacao(value)}
                                            noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                            multi={false} />
                                    <Validacao id="justificativaContratacaoId"
                                               valor={this.props.controller.solicitacao.justificativaContratacaoId}
                                               tipo={["isRequired", 
                                                        "mesmaJustificativa", mesmaJustificativa, 
                                                        "justificativaCusteioDireto", bloqueioJustificativaCusteioDireto]}/>
                                    <span style={{color: 'red', display: 'block'}}>{msgValidacaoJustificativaProrrgacao}</span>
                                </div>
                            ) : (
                                <Input value={_.get(solicitacao, "justificativaContratacao.nome")} readOnly/>
                            )}
                        </FormGroup>
                    </Col>
                    {exibeDetalhesJustificativa &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Risco da justificativa/alocação</Label>
                            <Input type="text" value={_.get(solicitacao, "justificativaContratacao.classificacaoRisco","")} readOnly />
                        </FormGroup>
                    </Col>
                    }
                </Row>
                {exibeDetalhesJustificativa &&
                <Row>
                    <Col xs={12} md={6} lg={12}>
                        <FormGroup>
                            <Label>Fato gerador</Label>
                            <Input type="text" value={_.get(solicitacao, "fatoGerador.nome", "")} readOnly/>
                        </FormGroup>
                        <FormGroup>
                            <label>Projeto/centro de resultado/finalidade {
                                    _.get(this.props.controller.solicitacao, "justificativaContratacaoId") && _.get(this.props.controller.solicitacao, "justificativaContratacao.justificativaAlocavel") === "SIM" && componenteEditavel && isProdutoEditavel &&
                                    <sup>*</sup>
                                }
                            </label>
                            {componenteEditavel && isProdutoEditavel && !bloqueioJustificativaCusteioDireto ? (
                                <div>
                                    <Select 
                                        value={this.props.controller.produtoSelecionado}
                                        valueKey={"id"}
                                        labelKey={"label"}
                                        autoload={false}
                                        onChange={(value, options) => this.props.controller.setProduto(value, options)}
                                        noResultsText="Nenhum resultado encontrado"
                                        placeholder="Selecione..."
                                        searchPromptText="Informe algum termo para pesquisar"
                                        asyncOptions={(input, callback) => this.props.controller.filtrarProdutos(input, callback)}/>
                                    {this.props.controller.solicitacao.justificativaContratacao.produtoOracle &&
                                        <span style={{ color: 'darkorange', display: 'block' }}>{"O custeio mensal ocorrerá exclusivamente nesta chave."}</span>
                                    }
                                    {_.get(this.props.controller.solicitacao.justificativaContratacao, "justificativaAlocavel") === "SIM" &&
                                    <Validacao id="produto" valor={this.props.controller.solicitacao.produtoId}
                                               tipo={["isRequired"]}/>
                                    }
                                </div>
                            ) : (
                                <Input type="text" value={_.get(solicitacao, "produto.nome") && _.get(solicitacao, "produto.codigo") ?
                                    solicitacao.produto.nome + ' (' + solicitacao.produto.codigo + ')' : _.get(solicitacao, "produto.label") ? solicitacao.produto.label : null} readOnly/>
                            )}

                        </FormGroup>
                    </Col>
                    <Col xs={12} lg={12}>
                        <FormGroup>
                            <Label>Detalhamento da justificativa/alocação</Label>
                            {componenteEditavel ? (
                                <Input type="textarea" maxLength={1024} value={this.props.controller.solicitacao.detalhamentoJustificativa} onChange={(event) => this.props.controller.setDetalhamentoJustificativa(event.target.value)}/>
                            ) : (
                                <Input type="textarea" value={_.get(solicitacao, "detalhamentoJustificativa","")} readOnly/>
                            )}
                        </FormGroup>
                    </Col>
                </Row>
                }
            </div>
        )
    }
}